import axios, { AxiosInstance, AxiosResponse } from 'axios';
import { API_CONSTANTS, API_HEADERS } from '../constants/api-constants';
import { attachMaiaAuth } from './auth/attachMaiaAuth';

const maiaApiInstance: AxiosInstance = axios.create({
  baseURL: API_CONSTANTS.MAIA_API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': API_HEADERS.CONTENT_TYPE,
  },
});

maiaApiInstance.interceptors.request.use(attachMaiaAuth, (error) =>
  Promise.reject(error),
);

maiaApiInstance.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error) => {
    if (error.response?.data) {
      error.message = error.response.data.message || error.message;
    }
    return Promise.reject(error);
  },
);

export default maiaApiInstance;
